"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSizeme = require("react-sizeme");

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _reactApollo = require("react-apollo");

var _commonReact = require("@devsta/common-react");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _api = require("../../BrandInfo/api");

var _PageSizeContext = require("../contexts/PageSizeContext");

var _SubBrand = _interopRequireDefault(require("../components/SubBrand"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SubBrand(_ref) {
  var history = _ref.history,
      subBrandId = _ref.match.params.id;
  return /*#__PURE__*/_react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref2) {
    var fetchAssets = _ref2.fetchAssets;
    return /*#__PURE__*/_react.default.createElement(_commonReact.AuthorisationConsumer, {
      requiresOrganisation: true
    }, function (_ref3) {
      var _ref3$selectedOrganis = _ref3.selectedOrganisation,
          organisationId = _ref3$selectedOrganis.organisationId,
          permissions = _ref3$selectedOrganis.permissions;
      return /*#__PURE__*/_react.default.createElement(_commonReact.RequestProvider, {
        requests: {
          deleteSubBrand: (0, _api.deleteSubBrandQuery)(organisationId),
          getOrganisationSubBrand: (0, _api.getOrganisationSubBrandQuery)(subBrandId),
          updateOrganisationSubBrand: (0, _api.updateOrganisationSubBrandQuery)(organisationId, subBrandId)
        }
      }, function (requests) {
        return /*#__PURE__*/_react.default.createElement(_reactApollo.ApolloConsumer, null, function (apolloClient) {
          return /*#__PURE__*/_react.default.createElement(_reactSizeme.SizeMe, null, function (_ref4) {
            var size = _ref4.size;
            return /*#__PURE__*/_react.default.createElement(_PageSizeContext.PageSizeProvider, {
              value: {
                containerSize: size
              }
            }, /*#__PURE__*/_react.default.createElement(_SubBrand.default, _extends({
              apolloClient: apolloClient,
              containerSize: size,
              history: history,
              subBrandId: subBrandId,
              fetchAssets: fetchAssets,
              organisationId: organisationId,
              orgPermissions: permissions
            }, requests)));
          });
        });
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, SubBrand);

exports.default = _default;